module.exports = __webpack_public_path__ + "static/20-8a2b214ad5373673e138f937436b4f00.jpg";